import ClinicalNoteWritingCategories from "./Categories";
import ClinicalNoteWritingCategoryAdd from "./Add";
import ClinicalNoteWritingCategoryEdit from "./Edit";
import ClinicalNoteWritingTopicAdd from "./AddTopic";
import ClinicalNoteWritingTopicEdit from "./EditTopic";

export const containers = {
  ClinicalNoteWritingCategories,
  ClinicalNoteWritingCategoryAdd,
  ClinicalNoteWritingCategoryEdit,
  ClinicalNoteWritingTopicAdd,
  ClinicalNoteWritingTopicEdit,
};



// WEBPACK FOOTER //
// ./src/modules/admin/clinicalNoteWriting/containers/index.js